import { MenuItem } from 'components/atoms';

export const getAccountManageItemKey = (accountManageItem: MenuItem) =>
    accountManageItem?.key ? (accountManageItem.key as string) : undefined;
